export const EVENTS = {
    PC_SCREEN_LANDING:
    {
        name: "PC_SCREEN_LANDING",
        schema: "iglu:com.medibuddy/PC_SCREEN_LANDING/jsonschema/2-0-0",
    },
    PC_LS_ACTION:
    {
        name: "PC_LS_ACTION",
        schema: "iglu:com.medibuddy/PC_LS_ACTION/jsonschema/2-0-0",
    },
    SERVICE_TYPE_OFFLINE_CONSULTS: 'OFFLINE_CONSULTS',
    SERVICE_NAME_OFFLINE_CONSULTS: 'LISTING_OF_SERVICE',
    SERVICE_TYPE_SPOC: 'SPOC',
    SERVICE_NAME_SPOC:"LISTING_OF_SPOC",
    APP_VERSION: 'v1.0',
    TAB_NAME_LC_SCREEN: '',
    TAB_NAME_ADD_EDIT_SCHEDULE: 'ADD_EDIT_SCHEDULE',
    TAB_NAME_ADD_EDIT_HOLIDAYS: 'ADD_EDIT_HOLIDAYS',
    TAB_NAME_ADD_EDIT_DOCTOR: 'ADD_EDIT_DOCTOR',
    TAB_NAME_ADD_EDIT_SPOC: 'ADD_EDIT_SPOC',
    ACTION: {
        FILTER: "FILTER_PAGE_UPDATE",
        PROFILE_STATUS: 'PROFILE_STATUS_CHANGE',
        EDIT_DOCTOR_ICON: 'CLICKED_ON_EDIT_DOCTOR',
        ADD_DOCTOR_ICON_CLICK: "ADD_DOCTOR_ICON_CLICK",
        EDIT_SLOTS_ICON: "EDIT_DOCTOR_SLOTS",
        EDIT_HOLIDAYS_ICON: "EDIT_DOCTOR_HOLIDAYS",
        SAVE_AND_PROCEED: "SAVE_AND_PROCEED",
        SUBMIT_TO_QC: "SUBMIT_TO_QC",
        SAVE_AS_DRAFT: "SAVE_AS_DRAFT",
        SAVE_SLOT: "SAVE_SLOT",
        SAVE_HOLIDAYS: "SAVE_HOLIDAYS",
        ADD_DOCTOR_PAGE: "LANDING_PAGE_FOR_ADD_DOCTOR",
        ADD_SCHEDULE_LANDING_PAGE: "LANDING_PAGE_FOR_ADDING_SCHEDULE",
        SCHEDULE_CREATED: "SCHEDULE_CREATED_OR_EDITED",
        ADD_HOLIDAYS_LANDING_PAGE: "ADD_HOLIDAYS_LANDING_PAGE",
        HOLIDAYS_CREATED: "HOLIDAYS_CREATED_OR_EDITED",
        SPOC_EDIT_SUBMIT: "SPOC_EDIT_SUBMIT",
        SPOC_ADD_SUBMIT: "SPOC_ADD_SUBMIT",
        SPOC_ADD_CLOSE: "SPOC_ADD_CLOSE",
        SPOC_EDIT_CLOSE: "SPOC_EDIT_CLOSE",
        SPOC_EDIT: "SPOC_EDIT",
        SPOC_ADD: "SPOC_ADD",
        SPOC_PROFILE_STATUS: 'SPOC_PROFILE_STATUS_CHANGE',
        ADD_EDIT_CUT_OFF: "ADD_EDIT_CUT_OFF",
        SAVE_CUT_OFF: "SAVE_CUT_OFF",
        OPEN_CUT_OFF_DIALOG: "OPEN_CUT_OFF_DIALOG",
        
    },
    TAB_NAME: {
        ADD_DOCTOR: "ADD_DOCTOR_PAGE",
        ADD_SCHEDULE: "ADD_SCHEDULE",
        ADD_HOLIDAYS: "ADD_HOLIDAYS",
        ADD_SPOC: "ADD_SPOC",
    }
}